import { render } from "./harvesterhci.io.virtualmachineimage.vue?vue&type=template&id=47384e08&scoped=true"
import script from "./harvesterhci.io.virtualmachineimage.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.virtualmachineimage.vue?vue&type=script&lang=js"

import "./harvesterhci.io.virtualmachineimage.vue?vue&type=style&index=0&id=47384e08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47384e08"]])

export default __exports__